import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import QuizInfo from "../QuizInfo/quizinfo"

class Modules extends Component {

    render() {
        this.props.modulesData.contents.sort(function (a,b) {
            return a.sequence - b.sequence;
        });
        return (
            <ExpansionPanel expanded={this.props.state.quizListPanel === this.props.index} onChange={this.props.quizList(this.props.index)}>
                <ExpansionPanelSummary 
                    expandIcon={<ExpandMoreIcon />}
                    style={{ 
                        backgroundColor : this.props.state.quizListPanel === this.props.index ? 'darkgrey' : 'white'
                        }}
                    className="module-list-panel">
                    Module Name : {this.props.modulesData.name}
                </ExpansionPanelSummary>
                {this.props.modulesData.contents && this.props.modulesData.contents.length && this.props.modulesData.contents.map((data, index) => {
                    return <QuizInfo key={index}
                                    index={index}
                                    quizDetails={this.props.quizDetails}
                                    data={data}
                                    classDetails={this.props.classDetails}
                                    userDetails={this.props.userDetails}
                                    state={this.props.state}
                                    quizData={this.props.quizData}
                            />
                })}
            </ExpansionPanel>
        )
    }
}

export default Modules


// WEBPACK FOOTER //
// ./src/container/Modules/modules.js